import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import { employeeLinksOverviewResponseSchema } from "./schemas";

export const employeeLinksOverviewQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "employee", "links-overview"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/employee/links/overview",
  responseSchema: employeeLinksOverviewResponseSchema,
});
